import T from 'prop-types'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Button } from '@/common/components/ui/button'

const schema = yup.object({
  email: yup.string().email("Incorrect email").required("Email is required").lowercase("Email must be lowercase"),
  fullName: yup.string().min(3, "More than 3 letters").required(),
  team: yup.string().oneOf(['user', 'ops'], 'Role must be user or ops').required('Role is required'),
}).required()

function EmployeeForm({ fullName = '', email = '', team = '', submitLabel = 'Submit', onCancel, onSubmit }) {
  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { fullName, email, team: team || 'user' },
  })

  useEffect(() => {
    setValue('fullName', fullName)
    setValue('email', email)
    setValue('team', team || 'user')
  }, [setValue, fullName, email, team])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mx-auto flex flex-col">
        <label className="flex flex-col my-[5px]">
          <p className="my-auto py-[5px]">Full Name</p>
          <input className="rounded border border-[rgb(134,134,134)] my-[5px] h-[30px]" {...register('fullName')} />
          <p className="text-[#f5554f] m-0">{errors.fullName?.message}</p>
        </label>
        <label className="flex flex-col my-[5px]">
          <p className="my-auto py-[5px]">Email</p>
          <input className="rounded border border-[rgb(134,134,134)] my-[5px] h-[30px]" {...register('email', { required: true })} />
          <p className="text-[#f5554f] m-0">{errors.email?.message}</p>
        </label>
        <label className="flex flex-col my-[5px]">
          <p className="my-auto py-[5px]">Role</p>
          <select className="rounded border border-[rgb(134,134,134)] my-[5px] h-[35px]" {...register('team')}>
            <option value="user">user</option>
            <option value="ops">ops</option>
          </select>
          <p className="text-[#f5554f] m-0">{errors.team?.message}</p>
        </label>
        <div className="flex flex-row justify-center gap-2 mt-2">
          <Button variant="destructive" type="button" onClick={onCancel}>Cancel</Button>
          <Button type="submit">{submitLabel}</Button>
        </div>
      </div>
    </form>
  )
}

EmployeeForm.propTypes = {
  fullName: T.string,
  email: T.string,
  team: T.string,
  submitValue: T.string,
  onCancel: T.func.isRequired,
  onSubmit: T.func.isRequired,
}

export default EmployeeForm
